'use client';

import ErrorView from '@/components/ErrorView';
import NormalPageActiveColumn from '@/components/normal-page-active-column';

export default function Error({ error }) {
  return (
    <>
      <ErrorView message={error.message} />
      <NormalPageActiveColumn />
    </>
  );
}
